import * as angular from 'angular';

export class ManageUsersEditPermissionsModal {
  static $inject: string[] = ['$mdDialog'];

  constructor(private $mdDialog) {}

  show(ids: string[]) {
    return this.$mdDialog.show({
      // resolve: {
      // },
      locals: {
        ids,
      },
      disableParentScroll: true,
      template: require('./manage-users-edit-permissions-modal.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      controller: 'ManageUsersEditPermissionsModalCtrl',
      controllerAs: '$ctrl',
    });
  }
}
